import React from "react";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { cn } from "../lib/utils";

// Telephone input with a country selector (flag + dial code) and E.164 output.
export default function PhoneField({ value, onChange, testId = "phone-input", defaultCountry = "CM", invalid = false, placeholder = "Enter phone number" }) {
  return (
    <div className={cn("phone-field", invalid && "phone-field--invalid")} data-testid={testId}>
      <PhoneInput
        international
        defaultCountry={defaultCountry}
        value={value || undefined}
        onChange={(v) => onChange(v || "")}
        placeholder={placeholder}
        numberInputProps={{ "data-testid": `${testId}-number` }}
      />
    </div>
  );
}
